import {useEffect} from 'react';
import {tagClarityEvent} from '../utils/clarity';
import {isProd, isSandbox} from '../utils/envHelper';

export const useClarityPageView = (
  pageName: string,
  userRole?: string,
  properties?: Record<string, string>,
) => {
  useEffect(() => {
    if (isProd || isSandbox) {
      tagClarityEvent('page_view', {
        page: pageName,
        ...(userRole && {user_role: userRole}),
        ...properties,
      });
    }
  }, [pageName, userRole, properties]);
};
